import { render, staticRenderFns } from "./NoSubmissionSelectedView.vue?vue&type=template&id=27f25080&scoped=true"
import script from "./NoSubmissionSelectedView.vue?vue&type=script&lang=js"
export * from "./NoSubmissionSelectedView.vue?vue&type=script&lang=js"
import style0 from "./NoSubmissionSelectedView.vue?vue&type=style&index=0&id=27f25080&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f25080",
  null
  
)

export default component.exports